import { csx } from '@vtex/admin-ui'

export const styles = {
  infoTemplateContainer: csx({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '$space-2 $space-8',
    gap: '$space-2',
    position: 'sticky',
    top: '92px',
    zIndex: '799',
    borderBottom: '$neutral',
    boxShadow: '$overlay.center',
    button: {
      marginLeft: 'auto',
    },
    '&[data-variant="info"]': {
      background: '$info',
    },
    '&[data-variant="neutral"]': {
      background: '$secondary',
    },
  }),
}
